import ShiningStar from "./Assets/ShiningStar.jpeg";
import SaamaOneYear from "./Assets/One_Year_Saama.jpeg";
import Appreciation from "./Assets/Appreciation.jpg";
import GenerativeAI from "./Assets/Generative-AI.jpg";
import Hackathon from "./Assets/Hackathon.jpeg";
import Clothifyy from "./Assets/Clothify.jpg";
import Shopmart from "./Assets/ShopMart.png";
import Rental from "./Assets/Rental.png";
import GymHolic from "./Assets/GymHolic.png";
import LearnHub from "./Assets/LearnHub.jpeg";
import ExpenseMate from "./Assets/ExpenseMate.png";
import Quizy from "./Assets/Quizy.png";
import ConnectNow from "./Assets/ConnectNow.png";
import WeatherNow from "./Assets/WeatherNow.png";
import Clothify from "./Assets/Clothify.png";
import Python from "./Assets/PythonCertificate.jpg";
import Snowflake from "./Assets/Snowflake.jpg";
import SQL from "./Assets/SQL-Certificate.jpg";
import TechBoy from "./Assets/TechBoy.png";
import GenAI from "./Assets/GenAI_Cohort.png";
import GenAI1 from "./Assets/IBM-GenAI.jpg";
import GenAI2 from "./Assets/IBM-GenAI(1).jpg";

export const Bio = {
  name: "Suraj Yadav",
  roles: ["Software Engineer", "AI Engineer"],
  description:
    "Software Engineer with 5+ years of professional experience in developing scalable web applications and backend services. Specialized in JavaScript with Typescript, Python, React.js, Next.js, FastAPI, Node.js and Snowflake with hands-on experience in AWS, SQL and emerging technologies such as Generative AI. Driven by continuous learning and collaboration to foster innovation.",
  github: "https://github.com/sarry7045",
  resume:
    "https://drive.google.com/file/d/1-CCUvdQ6d1PcP9Vs7O4XGeBn60YFyOPB/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/suraj-yadav-01752b222/",
  insta: "https://www.instagram.com/suraj.28_11/",
  facebook: "https://www.facebook.com/profile.php?id=100010635822203",
  mail: "mailto: surajyadav112820@gmail.com",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "TypeScript",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/typescript/typescript-original.svg",
      },
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },

      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "TanStack",
        image:
          "https://tanstack.com/images/logos/splash-light.png",
      },
      {
        name: "Redux",
        image:
          "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
      },
      // {
      //   name: "React Testing Library",
      //   image:
      //     "https://res.cloudinary.com/dg3gyk0gu/image/upload/v1700500148/tags/testing-library.png",
      // },
      // {
      //   name: "HTML",
      //   image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      // },
      // {
      //   name: "CSS",
      //   image:
      //     "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      // },
      // {
      //   name: "Bootstrap",
      //   image:
      //     "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      // },
      // {
      //   name: "Material UI",
      //   image:
      //     "data:image/png;base64,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",
      // },
      {
        name: "Tailwind CSS",
        image:
          "https://w7.pngwing.com/pngs/293/485/png-transparent-tailwind-css-hd-logo.png",
      },
      // {
      //   name: "ANTD",
      //   image:
      //     "https://static-00.iconduck.com/assets.00/ant-design-icon-2048x2046-dl3neb73.png",
      // },
      {
        name: "ShadCN",
        image:
          "https://images.seeklogo.com/logo-png/51/2/shadcn-ui-logo-png_seeklogo-519786.png",
      },
      // {
      //   name: "React i18Next",
      //   image: "https://translate.i18next.com/i18next.png",
      // },
      // {
      //   name: "Sass",
      //   image:
      //     "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/sass/sass-original.svg",
      // },
      // {
      //   name: "PWA",
      //   image:
      //     "https://uxwing.com/wp-content/themes/uxwing/download/brands-and-social-media/pwa-icon.png",
      // },
      // {
      //   name: "React Hook Form",
      //   image: "https://avatars.githubusercontent.com/u/53986236?s=280&v=4",
      // },
      // {
      //   name: "React Router Dom",
      //   image: "https://www.svgrepo.com/show/354262/react-router.svg",
      // },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      // {
      //   name: "Express Js",
      //   image:
      //     "data:image/png;base64,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",
      // },
      {
        name: "Python",
        image:
          "https://cdn3.iconfinder.com/data/icons/logos-and-brands-adobe/512/267_Python-512.png",
      },
      {
        name: "FastAPI",
        image: "https://avatars.githubusercontent.com/u/156354296?s=280&v=4",
      },
      // {
      //   name: "MongoDB",
      //   image:
      //     "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      // },
      {
        name: "PostGres",
        image:
          "https://w7.pngwing.com/pngs/170/924/png-transparent-microsoft-sql-server-microsoft-azure-sql-database-microsoft-text-logo-microsoft-azure.png",
      },
      {
        name: "Snowflake",
        image:
          "https://p.kindpng.com/picc/s/191-1912861_snowflake-data-warehouse-icon-hd-png-download.png",
      },
      // {
      //   name: "Firebase",
      //   image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      // },
      {
        name: "NGINX",
        image: "https://www.svgrepo.com/show/373924/nginx.svg",
      },
      {
        name: "Pydantic",
        image: "https://pydantic.dev/favicon/favicon.ico",
      },
      {
        name: "NumPy",
        image: "https://img.icons8.com/color/1200/numpy.jpg",
      },
      {
        name: "Pandas",
        image: "https://img.icons8.com/color/512/pandas.png",
      },
      // {
      //   name: "Web Socket",
      //   image:
      //     "https://iotbytes.wordpress.com/wp-content/uploads/2017/01/websocket-logo.png",
      // },
      {
        name: "Kafka",
        image:
          "https://openwhisk.apache.org/images/icons/icon-kafka-white-trans.png",
      },
      // {
      //   name: "GraphQL",
      //   image: "https://p7.hiclipart.com/preview/292/912/891/graphql-query-language-representational-state-transfer-application-programming-interface-github.jpg",
      // },
      // {
      //   name: "Gen AI",
      //   image: "https://img.freepik.com/premium-vector/black-white-ai-app-icon_1015334-244.jpg",
      // },
    ],
  },
  {
    title: "GenAI",
    skills: [
      {
        name: "LLM's",
        image: "https://twimlai.com/wp-content/uploads/llms_800x800.png",
      },
      {
        name: "LangChain",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langgraph-color.png",
      },
      {
        name: "LangGraph",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/langgraph-color.png",
      },
      {
        name: "BedRock",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/bedrock-color.png",
      },

      {
        name: "LlamaIndex",
        image:
          "https://registry.npmmirror.com/@lobehub/icons-static-png/latest/files/dark/llamaindex-color.png",
      },

      {
        name: "MCP Server's",
        image:
          "https://cdn.prod.website-files.com/647618f73e4f16d380e8eed9/67e414f6be9648cb1ca8d8e4_mcp.png",
      },
      // {
      //   name: "A2A",
      //   image:
      //     "https://companieslogo.com/img/orig/A2A.MI-ea3e20d3.png?t=1730097905",
      // },
      {
        name: "Qdrant",
        image: "https://avatars.githubusercontent.com/u/73504361?v=4",
      },
      {
        name: "Neo4J",
        image:
          "https://images.seeklogo.com/logo-png/27/2/neo4j-logo-png_seeklogo-273740.png",
      },
      // {
      //   name: "Mem0",
      //   image:
      //     "https://media.licdn.com/dms/image/v2/D560BAQEKCL-NcwJ59g/company-logo_200_200/company-logo_200_200/0/1720819731793/mem0_logo?e=2147483647&v=beta&t=Fseh27rIEmtK5XbU3yOlbxOO-ufWJGqqlH-WDhMVLjU",
      // },
    ],
  },
  {
    title: "DevOps",
    skills: [
      {
        name: "Docker",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
      },
      {
        name: "AWS",
        image:
          "https://logos-world.net/wp-content/uploads/2021/08/Amazon-Web-Services-AWS-Emblem.png",
      },
      {
        name: "Github Actions",
        image:
          "https://avatars.githubusercontent.com/u/44036562?s=280&v=4",
      },
    ],
  },
  {
    title: "Android",
    skills: [
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "React Native",
        image:
          "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      },
    ],
  },
  // {
  //   title: "Others Tools",
  //   skills: [
  //     {
  //       name: "Git",
  //       image:
  //         "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
  //     },
  //     {
  //       name: "BitBucket",
  //       image:
  //         "https://w7.pngwing.com/pngs/404/31/png-transparent-bitbucket-icon-hd-logo.png",
  //     },
  //     {
  //       name: "Stripe",
  //       image:
  //         "https://a.slack-edge.com/2a8628a/img/plugins/stripe/service_512.png",
  //     },
  //     {
  //       name: "StoryBook",
  //       image: "https://www.svgrepo.com/show/354397/storybook-icon.svg",
  //     },
  //     {
  //       name: "Sentry",
  //       image:
  //         "https://e7.pngegg.com/pngimages/282/295/png-clipart-red-illustration-sentry-logo-icons-logos-emojis-tech-companies-thumbnail.png",
  //     },
  //     {
  //       name: "PostHog",
  //       image: "https://www.moengage.com/wp-content/uploads/PostHog-icon.png",
  //     },
  //     {
  //       name: "Motion",
  //       image: "https://cdn.worldvectorlogo.com/logos/framer-motion.svg",
  //     },
  //     {
  //       name: "Vercel",
  //       image: "https://www.svgrepo.com/show/354513/vercel-icon.svg",
  //     },
  //     {
  //       name: "Postman",
  //       image:
  //         "https://static-00.iconduck.com/assets.00/postman-icon-497x512-beb7sy75.png",
  //     },
  //     {
  //       name: "Figma",
  //       image:
  //         "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
  //     },
  //   ],
  // },
];

export const experiences = [
  {
    id: 0,
    img: "https://mms.businesswire.com/media/20221005005781/en/591798/23/saama_logo_blue_blk_cmyk_highres.jpg",
    role: "Senior Software Engineer",
    company: "Saama Technologies",
    date: "July 2023 - Present",
    desc: `● Designed and implemented multiple POCs on Retrieval-Augmented Generation (RAG) leveraging LangChain,
vector databases, and LLMs to enhance trial data insights and knowledge retrieval.
● Developed and deployed scalable backend APIs using FastAPI, enabling efficient data processing and seamless
integration with ML/AI models.
● Built and optimized frontend components with React.js and ensured smooth API integration with Node.js,
improving user experience and system reliability.
● Collaborated cross-functionally with stakeholders to deliver secure, compliant, and high-performance solutions for
pharma study specifications and trial data analysis.`,
    skills: [
      "JavaScript",
      "TypeScript",
      "ReactJS",
      "Python",
      "Redux",
      "NodeJs",
      "Gen AI",
      "AWS",
      "Docker",
      "Material UI",
      "Tailwind CSS",
      "Motion",
      "Sass",
    ],
  },
  {
    id: 1,
    img: "https://s3.ap-south-1.amazonaws.com/assets.ynos.in/startup-logos/YNOS333312.jpg",
    role: "Frontend Engineer",
    company: "WealthDesk",
    date: "Aug 2022 - Jul 2023",
    desc: "• Develop and maintain pages to match business Requirements. Worked on EWG (Embedded WealthDesk Gateway) Broker Auth Integration, Broker Order Placement, Customer Queries. Reduced API calls by 20%. Dockerized for monitoring. Also Worked on Page Optimization. ",
    skills: [
      "JavaScript",
      "TypeScript",
      "ReactJS",
      "Redux",
      "Sass",
      "ShadCN",
      "StoryBook",
      "Sentry",
      "Docker",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTEU0UFoWbeo0CT0YHHhJxt9O5ogRsQbAEAxA&usqp=CAU",
    role: "ReactJs Developer",
    company: "Paymentz",
    date: "Sep 2021 - Aug 2022",
    desc: "• Worked on M-Transact - Online Payment App, with MVVM Architecture using JavaScript, NodeJs, Redux, PostHog, React-i18Next etc. Integrated API’s using Redux and Converted Figma design to JSX code.",
    skills: [
      "JavaScript",
      "ReactJS",
      "Redux",
      "NodeJs",
      "Sass",
      "Figma",
      "PostHog",
      "React-i18Next",
      "Git",
    ],
  },
  {
    id: 3,
    img: "https://media.licdn.com/dms/image/C510BAQGEWm0Vu9Ye7w/company-logo_200_200/0/1630613156150?e=2147483647&v=beta&t=FYD6GM8BBqkC7aH5xvoD0eQt7f5DmtYr_De2n9ywgvY",
    role: "Web Developer",
    company: "IXAR",
    date: "Sep 2020 - Sep 2021",
    desc: "Worked as a Web Developer and build beautiful Responsive Website using HTML, CSS, ReactJs, Material-UI etc. Also Performed SEO for Website, In order to Rank them on Google Search Engine.",
    skills: [
      "ReactJS",
      "HTML",
      "CSS",
      "BootStap",
      "Figma",
      "React-Router",
      "GitHub",
    ],
    // doc: "https://firebasestorage.googleapis.com/v0/b/flexi-coding.appspot.com/o/1691181448873.jpeg?alt=media&token=ee85eb8f-7247-43cd-9a1d-ce9f58ea62a6",
  },
];

// export const education = [
//   {
//     id: 0,
//     img: "",
//     school: "",
//     date: "Oct 2021 - Sep 2025",
//     grade: "8.10 CGPA",
//     desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Mumbai University. I have completed 6 semesters and have a CGPA of 8.10. I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
//     degree: "Bachelor in Information Technolgy",
//   },
// ];

export const projects = [
  // {
  //   id: 6,
  //   title: "TechBoy",
  //   date: "",
  //   description:
  //     "Introducing 'TechBoy,' Uncover the secrets of coding, tech innovations, and industry breakthroughs. Stay curious, stay ahead—dive into the future of technology with us!.",
  //   image: TechBoy,
  //   tags: [
  //     "TypeScript",
  //     "React Js",
  //     "Redux",
  //     "Framer Motion",
  //     "TailWind",
  //     "NodeJS",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/sarry7045/Tech-Boy",
  //   webapp: "https://dev.techboy.in/",
  // },
  {
    id: 11,
    title: "ShopMart",
    date: "",
    description:
      "Introducing 'ShopMart,' a dynamic and user-friendly shopping web application designed to the online shopping experience. ShopMart seamlessly blends cutting-edge technology with an intuitive interface to offer users a personalized and efficient way to discover, explore, and purchase their favorite products.",
    image: Shopmart,
    tags: [
      "JavaScript",
      "React Js",
      "Context API",
      "Framer Motion",
      "Styled Component",
    ],
    category: "web app",
    github: "https://github.com/sarry7045/E-Commerce-Web",
    webapp: "https://shopp-mart.netlify.app/",
  },
  {
    id: 9,
    title: "Rental",
    date: "",
    description:
      "Introducing 'Rental,' web application that redefines the way individuals search for their homes. Rental is a comprehensive house search platform designed to simplify the property hunting process and empower users with the tools they need to find the perfect place to call home",
    image: Rental,
    tags: [
      "JavaScript",
      "Next Js",
      "Context API",
      "Framer Motion",
      "Material UI",
    ],
    category: "web app",
    github: "https://github.com/sarry7045/Rental",
    webapp: "https://rentall.vercel.app/",
  },
  // {
  //   id: 0,
  //   title: "GymHolic",
  //   date: "",
  //   description:
  //     "Introducing 'GymHolic,' a cutting-edge Website designed to elevate your fitness journey by providing a rich collection of gym exercise images and videos. GymHolic is more than just a repository of workouts; it's a comprehensive platform that inspires and guides users towards achieving their fitness goals with a vast library of high-quality visual content.",
  //   image: GymHolic,
  //   tags: [
  //     "JavaScript",
  //     "React Js",
  //     "Context API",
  //     "Framer Motion",
  //     "HTML, CSS",
  //     "Material UI",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/sarry7045/Gymholic",
  //   webapp: "https://gymholic.netlify.app/",
  // },
  {
    id: 5,
    title: "Clothify",
    date: "",
    description:
      "Introducing 'Clothify,' a dynamic and user-friendly shopping web application designed to the online shopping experience. Clothify seamlessly blends cutting-edge technology with an intuitive interface to offer users a personalized and efficient way to discover, explore, and purchase and pay their favorite products.",
    image: Clothify,
    tags: [
      "JavaScript",
      "React Js",
      "Context API",
      "HTML, CSS",
      "GraphQL",
      "Stripe",
      "FireBase",
    ],
    category: "web app",
    github: "https://github.com/sarry7045/Clothify",
    webapp: "https://clothifyshopping.netlify.app/",
  },
  {
    id: 1,
    title: "LearnHub",
    date: "",
    description:
      "Introducing 'LearnHub,' an user-friendly mobile application designed to bring the online education courses to the fingertips of learners everywhere. LearnHub is a comprehensive platform that connects students with a diverse range of courses, fostering continuous learning and personal development.",
    image: LearnHub,
    tags: [
      "JavaScript",
      "React Native",
      "Context API",
      "Andrioid Studio",
      "HTML, CSS",
      "Axios",
    ],
    category: "android app",
    github: "https://github.com/sarry7045/ABC-Company",
    webapp: "https://mern-client-side.netlify.app/",
  },

  {
    id: 10,
    title: "Expense Mate",
    date: "",
    description:
      "Introducing 'Expense Mate,' a straightforward and efficient expense tracker application designed to empower users with the ability to manage their finances effortlessly. ExpenseMate is a user-friendly solution for tracking expenses, offering a practical and organized approach to financial management.",
    image: ExpenseMate,
    tags: [
      "JavaScript",
      "React Js",
      "Material UI",
      "Context API",
      "React-Icons",
    ],
    category: "web app",
    github: "https://github.com/sarry7045/Expense-Tracker",
    webapp: "https://expense-trracker.netlify.app/",
  },
  {
    id: 2,
    title: "Quizy",
    date: "",
    description:
      "Welcome to 'Quizy,' a captivating website that brings the excitement of quizzes right to your fingertips. Quizy is a user-friendly quiz game website designed to entertain, challenge, and engage users with a variety of interesting questions and topics.",
    image: Quizy,
    tags: [
      "TypeScript",
      "React Js",
      "Context API",
      "Bootstrap",
      "Styled Component",
    ],
    category: "web app",
    github: "https://github.com/sarry7045/Quiz-App",
    webapp: "https://quizzzzzz-app.netlify.app/",
  },
  // {
  //   id: 3,
  //   title: "ConnectNow",
  //   date: "",
  //   description:
  //     "Introducing 'ConnectNow,' a versatile video chat application that facilitates seamless communication and connection between individuals. ConnectNow is a user-friendly and efficient platform designed to provide a basic yet reliable video chat experience.",
  //   image: ConnectNow,
  //   tags: ["JavaScript", "React Js", "Socket.IO", "Express", "Nodemon"],
  //   category: "web app",
  //   github: "https://github.com/sarry7045/Video-Chat-App",
  //   webapp: "https://videeo-chatt-app.netlify.app/",
  // },
  // {
  //   id: 4,
  //   title: "WeatherNow",
  //   date: "",
  //   description:
  //     "Introducing 'WeatherNow,' a simple and reliable weather application designed to provide users with real-time weather updates and forecasts at their fingertips. WeatherNow is a user-friendly solution that makes staying informed about the weather conditions effortless and enjoyable.",
  //   image: WeatherNow,
  //   tags: ["JavaScript", "React Js", "HTML", "CSS", "REST API's"],
  //   category: "web app",
  //   github: "https://github.com/sarry7045/Weather-App",
  //   webapp: "https://react-weatther-app.netlify.app/",
  // },
];

export const achievements = [
  {
    id: 1,
    title: "Appreciation Letter (NUIT Solution)",
    description: "",
    image: Appreciation,
    webapp:
      "https://drive.google.com/file/d/157L_ejvhV85tyc9IqikIh8qlh6k7z3gO/view?usp=drive_link",
  },
  {
    id: 2,
    title: "30 Hours GenAI Cohort",
    description: "",
    image: GenAI,
    webapp:
      "https://drive.google.com/file/d/12EElLj3vfG789YgIlKGpUaWuGQsqilBu/view?usp=sharing",
  },
  {
    id: 4,
    title: "Generative AI Essentials for Software Developers",
    description: "",
    image: GenAI2,
    webapp:
      "https://drive.google.com/file/d/1eGZ60lMfJXCV-vpKUdPwzCTUrdoHQnf9/view?usp=sharing",
  },
  {
    id: 9,
    title: "Hackathon 2024",
    description: "",
    image: Hackathon,
    webapp:
      "https://drive.google.com/file/d/1z0q_5ifPMIiQd3-WCO4oz-wlYEomnMc2/view?usp=drive_link",
  },
  {
    id: 3,
    title: "Python Bootcamp (100 Days)",
    description: "",
    image: Python,
    webapp:
      "https://drive.google.com/file/d/1iNvMYBhDJp5BcGXWM6s7heKydp8WzDVI/view?usp=sharing",
  },
  {
    id: 8,
    title: "Snowflake",
    description: "",
    image: Snowflake,
    webapp:
      "https://drive.google.com/file/d/1b6KRpAjm0oBbS8v8ntthPrsi9YhlSvQH/view?usp=sharing",
  },
  // {
  //   id: 8,
  //   title: "SQL Bootcamp",
  //   description: "",
  //   image: SQL,
  //   webapp:
  //     "https://drive.google.com/file/d/1ULT1MIUCI9Pb7L2IcfNT2d7FIdlK_pH8/view?usp=sharing",
  // },
  // {
  //   id: 4,
  //   title: "Advance ReactJs (Udemy)",
  //   description: "",
  //   image: Clothifyy,
  //   webapp:
  //     "https://drive.google.com/file/d/1tIVobJGNrLt1cUCGmCsWB4VvGJ5-bour/view?usp=drive_link",
  // },
  // {
  //   id: 5,
  //   title: "Generative AI (Saama)",
  //   description: "",
  //   image: GenerativeAI,
  //   webapp:
  //     "https://drive.google.com/file/d/1y3Wi6BC6iG143v63gPdcaw5_GO_Q-Rkt/view?usp=drive_link",
  // },
  // {
  //   id: 6,
  //   title: "Shining Star (Saama)",
  //   description: "",
  //   image: ShiningStar,
  //   webapp:
  //     "https://drive.google.com/file/d/1rlrofKTW0dxcqy8P_JWHRxK7y6LnDD-e/view?usp=drive_link",
  // },
  // {
  //   id: 7,
  //   title: "Saama One Year Appreciation",
  //   description: "",
  //   image: SaamaOneYear,
  //   webapp:
  //     "https://drive.google.com/file/d/1qCoiRvKqGZTvDnY_x3FDekxmm4eUWsH2/view?usp=sharing",
  // },
];
